import * as React from "react";
import moment from "moment";

type Props = {
  datetime_string: string;
};

const MomentRelativeDisplay: React.FunctionComponent<Props> = ({ datetime_string }: Props) => {
  const getTime = () => {
    const datetime = moment(new Date(datetime_string));
    if (datetime.isSame(new Date(), "day")) {
      return datetime.format("LT");
    } else {
      return datetime.format("llll");
    }
  };

  return <span>{getTime()}</span>;
};

export default MomentRelativeDisplay;
